import { yup } from '@framework/validation/initYup.ts';
import { MapLayerSchema } from '../../layers/schema/MapLayerSchema.ts';
import { type IMapPrintImage } from './MapPrintImage.ts';

export const MapPrintImageSchema: yup.ObjectSchema<IMapPrintImage> = yup
  .object({
    name: yup.string().required().label('Nome'),
    layers: yup
      .array(MapLayerSchema)
      .required()
      .min(1, 'È necessario configurare almeno un layer di sfondo'),
    fillColor: yup.string().required().label('Colore di riempimento'),
    fillOpacity: yup
      .number()
      .min(0)
      .max(1)
      .default(1)
      .required()
      .label('Opacità di riempimento'),
    strokeColor: yup.string().required().label('Colore del bordo'),
    strokeOpacity: yup
      .number()
      .min(0)
      .max(1)
      .default(1)
      .required()
      .label('Opacità del bordo'),
    strokeWidth: yup.number().min(0).required().label('Spessore del bordo'),
    padding: yup.number().min(0).required().label('Padding'),
  })
  .required();
